import { render, staticRenderFns } from "./AccountBuyNow.vue?vue&type=template&id=07e87f28&scoped=true&"
import script from "./AccountBuyNow.vue?vue&type=script&lang=js&"
export * from "./AccountBuyNow.vue?vue&type=script&lang=js&"
import style0 from "./AccountBuyNow.vue?vue&type=style&index=0&id=07e87f28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e87f28",
  null
  
)

export default component.exports